import WithdrawalForm from "./WithdrawalForm";
import WithdrawalList from "./WithdrawalList";

const PartnerWithdrawals = () => {
  const userData = JSON.parse(sessionStorage.getItem("user")) || {};
  const userId = userData.userId; // Fetch userId from session storage
  console.log("userId", userId);

  if (!userId) {
    return <p className="text-red-500">User not found. Please log in.</p>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Partner Withdrawals</h1>
      <WithdrawalForm userId={userId} />
      <WithdrawalList userId={userId} />
    </div>
  );
};

export default PartnerWithdrawals;
